module.exports = __webpack_public_path__ + "static/stop-0ff9037a3e08b97bc60a3a4d97ed2713.svg";